import { Modal } from "antd";
import CreateUserForm from "./CreateUserForm";

const EditUser = ({ user, isOpen, closeModal }) => {
  return (
    <Modal
      title={<></>}
      width="500px"
      open={isOpen}
      onCancel={closeModal}
      className="user-popup"
      footer={false}
    >
      <div className="mt20">
        <CreateUserForm initialValues={user} closeModal={closeModal} />
      </div>
    </Modal>
  );
};

export default EditUser;
